import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../assets/css/EditTenant.css";
import "../assets/css/DigixLeads.css";
import "../assets/css/AddSocialaccount.css";
import axiosInstance from "../components/api/axiosInstance";
import SocialAccountFields, {
  emptySocialAccountForm,
  socialAccountFormError,
  socialAccountPayload,
} from "../components/SocialAccountFields";
import { getAuthItem } from "../utils/authStorage";
import { formValueWithMobileSanitize } from "../utils/phone";

function AddAccount({ onBack, onAddAccount, initialClientId = "" }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(() => emptySocialAccountForm(initialClientId));

  useEffect(() => {
    if (initialClientId == null || initialClientId === "") return;
    setFormData((prev) => ({
      ...prev,
      clientId: String(initialClientId)
    }));
  }, [initialClientId]);

  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: formValueWithMobileSanitize(name, value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formError = socialAccountFormError(formData);
    if (formError) {
      alert(formError);
      return;
    }

    // Get Created_By from user
    let createdBy = 1;
    try {
      const userStr = getAuthItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        createdBy = user.user_id || user.id || 1;
      }
    } catch (err) {
      console.error("Error reading user for Created_By:", err);
    }

    const payload = { ...socialAccountPayload(formData), Created_By: createdBy };

    setSubmitting(true);
    try {
      const response = await axiosInstance.post('/create-social-account', payload);
      
      if (response.data) {
        alert("Account created successfully");
        if (onAddAccount) onAddAccount();
        if (onBack) onBack();
      } else {
        throw new Error("Create failed - no response data");
      }
    } catch (err) {
      console.error("Error creating account:", err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to create account.";
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="edittenant-container">
      <div className="viewlead-header">
        <button
          type="button"
          className="viewlead-back-link"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft /> Back
        </button>
      </div>
      <form className="edittenant-form" onSubmit={handleSubmit}>
        <SocialAccountFields form={formData} onChange={handleInputChange} />

        <div className="edittenant-actions">
          <button type="submit" className="addaccount-create-btn" disabled={submitting}>
            {submitting ? "Creating..." : "Create Account"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddAccount;
